// extracted by mini-css-extract-plugin
module.exports = {"container":"Sovendus_container__zehNh","loader":"Sovendus_loader__36qXP","sovendus":"Sovendus_sovendus__3BZdf"};